<template>
  <div>
    <CCard v-if="show">
      <CCardHeader>
        <CIcon name="cil-pencil"/>
        <strong> Faturamento </strong>
        <div class="card-header-actions">
          <CLink
            class="card-header-action btn-minimize"
            @click="collapsed = !collapsed">
            <CIcon :name="`cil-chevron-${collapsed ? 'top' : 'bottom'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="collapsed">
        <CCardBody>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <CForm>
              <CRow>
                <CCol sm="4">
                  <CInput
                    disabled
                    label="ERP"
                    v-model="form.erp"/>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="e-mail de acesso"
                    rules="required|max:50"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Login"
                      valid-feedback
                      v-model="form.login"
                      :invalid-feedback="errors[0]"
                      placeholder="Digite o e-mail de acesso"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="4">
                  <validation-provider
                    name="senha de acesso"
                    rules="required|max:20"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      label="Senha"
                      valid-feedback
                      v-model="form.senha"
                      :invalid-feedback="errors[0]"
                      placeholder="Digite a senha de acesso"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6">
                  <validation-provider
                    name="senha do certificado"
                    rules="required|max:20"
                    v-slot="{ errors, valid, touched }"
                  >
                    <CInput
                      valid-feedback
                      :invalid-feedback="errors[0]"
                      label="Senha Certificado Digital A1"
                      v-model="form.senhacertificado"
                      placeholder="Digite a senha do certificado"
                      :is-valid="touched == false ? null : valid ? true : false"
                    />
                  </validation-provider>
                </CCol>
                <CCol sm="6">
                  <label>Enviar Certificado</label>
                  <div class="form-group flex-column col-12 d-flex align-items-center">
                    <input
                      ref="file"
                      type="file"
                      class="d-none"
                      accept=".pfx"
                      @change="handleFile($event)" />
                    <button
                      type="button"
                      @click="openFileDialog()"
                      class="btn w-50 btn-secondary">
                      Adicionar Certificado
                    </button>
                    <div class="mt-2" v-if="files">
                      {{ files.name }}
                      <button
                        class="btn badge badge-danger"
                        @click="files = ''">
                        <i class="fas fa-trash"></i>
                      </button>
                    </div>
                    <div class="mt-2" v-if="form.file_name">
                      {{ form.file_name }}
                    </div>
                  </div>
                </CCol>
              </CRow>
              <CRow class="border-top">
                <CCol class="text-right">
                  <div class="mt-2">
                    <CButton
                      v-if="form.id"
                      class="mr-2"  
                      type="submit" 
                      color="success"
                      :disabled="invalid"
                      @click.prevent="update()">
                      Atualizar
                    </CButton>
                    <CButton
                      v-else
                      type="submit" 
                      color="primary"
                      :disabled="invalid"
                      @click.prevent="save()">
                      Enviar
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </validation-observer>
        </CCardBody>
      </CCollapse>
    </CCard>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'billingForm',
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        files: ''
      }
    },
    computed: {
      form: {
        get() {
          return this.$store.state.faturamento
        }
      },
      collapsed: {
        get() { 
          return this.$store.state.forms.collapsed.faturamento 
        },
        set() {
          this.$store.commit('setCollapsedTrue', 'faturamento')
        }
      }
    },
    methods: {
      ...mapActions(['saveFaturamento', 'updateBilling']),
      openFileDialog() {
        this.$refs.file.value = null;
        this.$refs.file.click();
      },
      handleFile({ target }) {
        this.files = target.files[0];
      },
      save() {
        var payload = new FormData()

        payload.append('erp', this.form.erp)
        payload.append('login', this.form.login)
        payload.append('senha', this.form.senha)
        payload.append('file', this.files)
        payload.append('senhacertificado', this.form.senhacertificado)

        this.saveFaturamento(this.form);
      },
      update() {
        var payload = new FormData()

        payload.append('erp', this.form.erp)
        payload.append('login', this.form.login)
        payload.append('senha', this.form.senha)
        payload.append('file', this.files)
        payload.append('senhacertificado', this.form.senhacertificado)
        
        this.updateBilling(this.form)
      }
    }
  }
</script>
